// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

//TODO: May or may not be removed in future, depending on whether we want to apply a ServiceGuard on Sensors
export const Route = createFileRoute('/$accountId/_user/sensors')({
  component: Outlet,
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'units-gateways-sensors:sensors.overviewTitle' },
});
